export const WHATSAPP_NUMBER = "37498114961";

export const CONTACT_PHONE_DISPLAY = "+374 98 114 961";

export const navLinks = [
  { key: "nav.home", href: "#home" },
  { key: "nav.services", href: "#services" },
  { key: "nav.fleet", href: "#fleet" },
  { key: "nav.how", href: "#how" },
  { key: "nav.pricing", href: "#pricing" },
  { key: "nav.service", href: "#service" },
  { key: "nav.faq", href: "#faq" },
  { key: "nav.contact", href: "#contact" },
];

export const heroStats = [
  { value: "450+", labelKey: "stats.riders" },
  { value: "120+", labelKey: "stats.vehicles" },
  { value: "24/7", labelKey: "stats.support" },
  { value: "AMD", labelKey: "stats.rates" },
];

export const marqueeItems = [
  { icon: "ri-motorbike-fill", key: "marquee.bike" },
  { icon: "ri-e-bike-2-fill", key: "marquee.scooter" },
  { icon: "ri-car-fill", key: "marquee.car" },
  { icon: "ri-tools-fill", key: "marquee.service" },
  { icon: "ri-settings-3-fill", key: "marquee.parts" },
  { icon: "ri-whatsapp-line", key: "marquee.whatsapp" },
  { icon: "ri-map-pin-2-fill", key: "marquee.location" },
];

export const services = [
  { id: "bike", icon: "ri-motorbike-fill" },
  { id: "scooter", icon: "ri-e-bike-2-fill" },
  { id: "car", icon: "ri-car-fill" },
  { id: "service", icon: "ri-tools-fill" },
  { id: "parts", icon: "ri-settings-3-fill" },
  { id: "roadside", icon: "ri-24-hours-fill" },
];

export const leaseSteps = [
  { id: "choose", number: "01", icon: "ri-search-line" },
  { id: "docs", number: "02", icon: "ri-file-list-3-line" },
  { id: "pay", number: "03", icon: "ri-hand-coin-line" },
  { id: "ride", number: "04", icon: "ri-motorbike-fill" },
];

export const pricingPlans = [
  { id: "bike", icon: "ri-motorbike-fill", price: "30,000", featured: false },
  { id: "scooter", icon: "ri-e-bike-2-fill", price: "17,000", featured: true },
  { id: "car", icon: "ri-car-fill", price: "55,000", featured: false },
];

export const pricingFeatureKeys = ["f1", "f2", "f3", "f4", "f5"];

export const testimonials = [
  {
    id: "davit",
    name: "Davit Petrosyan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Armenian%20delivery%20rider%20smiling%20wearing%20a%20casual%20jacket%20on%20a%20clean%20white%20studio%20background%2C%20photorealistic%20editorial%20portrait%2C%20warm%20natural%20lighting%2C%20sharp%20details&width=200&height=200&seq=arman-avatar-1-v2&orientation=squarish&nocache=true",
  },
  {
    id: "narek",
    name: "Narek Grigoryan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20confident%20Armenian%20man%20with%20short%20beard%20wearing%20a%20delivery%20uniform%20on%20a%20clean%20white%20studio%20background%2C%20photorealistic%20editorial%20portrait%2C%20warm%20natural%20lighting%2C%20sharp%20details&width=200&height=200&seq=arman-avatar-2-v2&orientation=squarish&nocache=true",
  },
  {
    id: "aram",
    name: "Aram Sargsyan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20middle%20aged%20Armenian%20taxi%20driver%20smiling%20wearing%20a%20simple%20shirt%20on%20a%20clean%20white%20studio%20background%2C%20photorealistic%20editorial%20portrait%2C%20warm%20natural%20lighting%2C%20sharp%20details&width=200&height=200&seq=arman-avatar-3-v2&orientation=squarish&nocache=true",
  },
];

export const faqs = [
  { id: "documents" },
  { id: "weekly" },
  { id: "support" },
  { id: "delivery" },
  { id: "breakdown" },
  { id: "sell" },
];

export const serviceHighlights = [
  { id: "workshop", icon: "ri-tools-fill" },
  { id: "parts", icon: "ri-settings-3-fill" },
  { id: "maintenance", icon: "ri-oil-fill" },
  { id: "guarantee", icon: "ri-shield-check-fill" },
];